import Panels from '../panels';

const salesButtonSelector = '[data-sale-button]';


const checkboxesSelector = '[data-toggle-sale]';


const bulkActionSelector = '[data-bulk-sale-action]';


const salesListingsContainerSelector = '[data-sales-listings-container]';

function init() {
  initEachSaleButton();

  // Certain AJAX'd forms load HTML with sale buttons that
  // necessitate re-initializing buttons in the DOM
  $(document).on('reverb.ajax_load.complete', salesListingsContainerSelector, (e) => {
    initEachSaleButton();
  });
}

function initEachSaleButton() {
  $(salesButtonSelector).each(initSaleButton);
}

function initSaleButton() {
  const $button = $(this);
  const saleButton = new Button($button);
  saleButton.init();
}

var Button = function ($button) {
  const self = this;
  self.$button = $button;
  self.$panel = null;
  const url = self.$button.prop('href');
  const onSaleClass = 'on-sale';

  self.init = function () {
    Panels.bindPanelTo($button, {
      ajaxUrl: url,
      loaded: panelLoaded,
      unhover: $button.parents('.product'),
      align: $button.data('align'),
      cssClass: 'sales-popout',
    });
  };

  function panelLoaded($panel) {
    self.$panel = $panel;
    initTips($panel);
    bindPanelEvents();
  }

  function numSalesSelected() {
    return self.$panel.find(checkboxesSelector).filter(':checked').length;
  }

  function runBulkAction(e) {
    e.preventDefault();

    const $this = $(this);
    const originalButtonText = $this.text();
    const errorContainer = $($this.data('error-selector'));
    errorContainer.hide();

    $this.prop('disabled', true);
    $this.addClass('btn-disabled');
    $this.text(I18n.t('js.wait'));

    $.post(this.href, () => {
      const msg = $this.data('success-message');
      $this.replaceWith(`<span class='color-green ph ph-l ph-check'>${msg}</span>`);
    }).fail(() => {
      $this.text(originalButtonText);
      errorContainer.show();
    });
  }

  function saleToggled(e) {
    const $checkbox = $(e.target);

    if (numSalesSelected() > 0) {
      $button.addClass(onSaleClass);
    } else {
      $button.removeClass(onSaleClass);
    }

    Reverb.RemoteCheckbox.submit($checkbox, {
      url: $checkbox.data('url'),
      done: toggleComplete,
    });
  }

  function bindPanelEvents() {
    self.$panel.find(checkboxesSelector).on('click', saleToggled);
    self.$panel.find(bulkActionSelector).on('click', runBulkAction);
  }

  function toggleComplete() {
    self.$panel.load(url, bindPanelEvents);
  }
};

export default {
  init,
};
